import { Case } from 'dashboard/models/case';
import { RelatedReport, Report } from 'dashboard/models/report';
import { ReportRun } from 'dashboard/models/report-run';
import { ReportTemplate } from 'dashboard/models/report-template';
import { Tag } from 'dashboard/models/tag';
import { ReportActions, ReportActionType } from 'dashboard/redux/actions/report';

export interface ReportState {
  report: Report | undefined;
  reportTemplate: ReportTemplate | undefined;
  tags: Tag[];
  cases: Case[];
  relatedReports: RelatedReport[];
  reportRuns?: ReportRun[];
}

export const initialState: ReportState = {
  report: undefined,
  reportTemplate: undefined,
  tags: [],
  cases: [],
  relatedReports: [],
  reportRuns: [],
};

const reportReducer = (state: ReportState = initialState, action: ReportActions): ReportState => {
  switch (action.type) {
    case ReportActionType.ClearReport: {
      return initialState;
    }

    case ReportActionType.SetReport: {
      return {
        ...state,
        report: action.payload.report,
      };
    }

    case ReportActionType.SetReportDetails: {
      return {
        ...state,
        reportTemplate: action.payload.reportTemplate,
        tags: action.payload.tags,
        cases: action.payload.cases,
        relatedReports: action.payload.relatedReports,
        reportRuns: action.payload.reportRuns,
      };
    }

    default:
      return state;
  }
};

export default reportReducer;
